import type { ReactNode } from 'react';

/** Sticky game-screen bottom zone: rack + action row (spec 10.2). */
export function BottomBar({ children }: { children: ReactNode }) {
  return (
    <div className="safe-bottom fixed inset-x-0 bottom-0 z-20 border-t border-stone-200 bg-white">
      <div className="mx-auto w-full max-w-content px-4 py-2">{children}</div>
    </div>
  );
}
